import { render, staticRenderFns } from "./vcDate.vue?vue&type=template&id=1456abe5&"
import script from "./vcDate.vue?vue&type=script&lang=js&"
export * from "./vcDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports